<template>
  <div class="container">
    <h1 style="font-size: 15px" v-if="needData.QuestionType===0">{{ '单选题' }}</h1>
    <h1  style="font-size: 15px" v-if="needData.QuestionType===1">{{ '多选题' }}</h1>
    <h1  style="font-size: 15px" v-if="needData.QuestionType===2">{{ '判断题' }}</h1>
    <div style="margin-top: 35px;margin-bottom: 40px;font-size: 15px">{{needData.QuestionTitle}}</div>
	  <div class="options"   v-for="(item,index) in needData.Options" >
		  <label v-if="needData.QuestionType === 1">
			  <input  type="checkbox" name="answer" :value="index" :checked="item.IsAnswer"  />
			  {{ getLetterByIndex(index) }}. {{ item.AnswerContent }}
		  </label>
		  <label v-else>
			  <input  type="radio" name="answer" :value="index" :checked="item.IsAnswer"  />
			  {{ getLetterByIndex(index) }}. {{ item.AnswerContent }}
		  </label>
	  </div>
    <div class="analysis" >
      <h2 style="font-size: 15px">题目解析</h2>
      <div style="color: #333;font-size: 15px">{{needData.Analysis}}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { getCollectionQuestionsData } from '@/api/api'

export default {
  name: 'ShareQuestions',
  data() {
    return {
      question: {
        title: '判断题',
        content: '',
        answer: '',
        analysis: ''
      },
	    needData:undefined,
      showAnalysis: false
    };
  },
  methods: {
	  getLetterByIndex(index) {
		  // 将数字索引转为 A, B, C...
		  return String.fromCharCode(65 + index); // ASCII 65 是 'A'
	  },
    async fetchQuestion() {
	    const id = this.$route.query.id;
	    const projectId = this.$route.query.projectId;
		  let requestParams = {
		    id: id ,
		    projectId: projectId
		  };
		  const res = await getCollectionQuestionsData(requestParams);
		  if (res.data.Success) {
		    console.log(res.data, 'res.data');
				this.needData = res.data.Response;
		  }
		},
    selectAnswer(answer) {
      this.question.answer = answer;
      this.showAnalysis = true;
    }
  },
  mounted() {
    this.fetchQuestion();
  }
	
};
</script>

<style scoped>
.container {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

p {
  font-size: 16px;
  margin-bottom: 20px;
}

.options {
  display: flex;
  flex-direction: column;
}

.options label {
	pointer-events: none;
  font-size: 16px;
	margin-bottom: 20px;
}

.analysis {
  margin-top: 20%;
  padding-bottom: 20px;
}

.analysis h2 {
  font-size: 20px;
  margin-bottom: 10px;
}

.analysis p {
  font-size: 14px;
}

@media (max-width: 600px) {
  .container {
    padding: 10px;
  }

  h1 {
    font-size: 20px;
  }

  p {
    font-size: 14px;
  }

  .options label {
    font-size: 14px;
  }

  .analysis h2 {
    font-size: 18px;
  }

  .analysis p {
    font-size: 12px;
  }
}
</style>
